var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pane-con"},[_c('van-nav-bar',{attrs:{"title":_vm.$route.meta.title,"left-text":"返回","left-arrow":"","right-text":_vm.rightText},on:{"click-right":_vm.onClickRight,"click-left":_vm.onClickLeft}}),_c('router-view',{ref:"paneView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }